// Module
var code = "<svg fill=none xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><path d=\"M3.332 11.382l6.256 6.135M19.135 6.055L9.672 17.6\" stroke-width=3 stroke-linecap=round /></svg> ";
// Exports
module.exports = code;